/**
 * Centralised post-login redirect logic.
 *
 * Telesales roles (`agent`, `telesales_director`) NEVER see the
 * project-centric `/dashboard` — they go straight to the Telesales-Home
 * which carries their full workflow (Erfassen / Mein Team / Submissions).
 *
 * Installers go to their job board.  Sales roles + Admins land on the
 * classic dashboard.
 */
export function postLoginDestination(user) {
  if (!user) return "/dashboard";
  // Pending-payment + pending-admin states take precedence
  if (user.status === "pending_admin") return "/register/pending-admin";
  const isAdminLike = user.role === "admin" || user.role === "super_admin" || user.is_super_admin === true;
  if (!isAdminLike && user.status === "pending") return "/select-plan";

  // Role-specific home
  if (user.role === "agent" || user.role === "telesales_director") return "/telesales";
  if (user.role === "installer") return "/installer/jobs";
  return "/dashboard";
}
